module.exports = __webpack_public_path__ + "img/logo.b1be0848.png";